"use strict";

exports.__esModule = true;
exports["default"] = exports.SearchInput = exports.SearchIcon = exports.SearchBar = exports.RefInput = exports.CancelIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _styles = require("@qc-modules/styles");

var _styledSystem = require("styled-system");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

var _utils = require("../../utils");

var _custom = _interopRequireDefault(require("../../primitives/custom"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SearchInput = (0, _styledComponents["default"])(_primitives["default"].Input).withConfig({
  displayName: "search-bar__SearchInput",
  componentId: "sc-17mgirz-0"
})(["", ";border:none;font-family:inherit;padding:0;text-indent:10px;&:focus{outline:none;}&::-ms-clear{display:none;}&::placeholder{color:", ";}"], _styledSystem.letterSpacing, function (props) {
  return (0, _styles.colors)("text-light-grey", props);
});
exports.SearchInput = SearchInput;

var RefInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var props = Object.assign({}, _ref);
  return /*#__PURE__*/_react["default"].createElement(SearchInput, _extends({}, props, {
    ref: ref
  }));
});

exports.RefInput = RefInput;
var SearchIcon = (0, _styledComponents["default"])(_elements.NavSearch).withConfig({
  displayName: "search-bar__SearchIcon",
  componentId: "sc-17mgirz-1"
})(["", ";", ";"], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.height, _styledSystem.width), _custom["default"]);
exports.SearchIcon = SearchIcon;
var CancelIcon = (0, _styledComponents["default"])(_elements.NavClose).withConfig({
  displayName: "search-bar__CancelIcon",
  componentId: "sc-17mgirz-2"
})(["cursor:pointer;", ";", ";"], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.height, _styledSystem.width), _custom["default"]);
exports.CancelIcon = CancelIcon;
var propTypes = {
  className: _propTypes.string,
  // Font object passed to the SearchInput component
  inputFont: (0, _propTypes.shape)({
    color: _propTypes.string,
    fontSize: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
    fontWeight: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
    height: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
    letterSpacing: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number]),
    lineHeight: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number])
  }),
  onCancelClick: _propTypes.func,

  /** If true then search term is submitted with enter key */
  onChange: _propTypes.func,

  /** Input onChange function */
  onFocus: _propTypes.func,
  onSubmit: _propTypes.func,

  /** Input onFocus function */
  placeholder: _propTypes.string,
  // Height for the outer Flex container
  searchBarHeight: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.array, _propTypes.string]),
  searchLabel: _propTypes.node,
  showCancel: _propTypes.bool,

  /** Input placeholder content */
  submitOnEnter: _propTypes.bool,

  /** Content rendered in suggestions container */
  suggestions: _propTypes.node,

  /** Input text value */
  value: _propTypes.string
};
var defaultProps = {
  inputFont: {
    color: "black",
    fontSize: [5, 6],
    fontWeight: 2,
    height: [35, 30],
    letterSpacing: "0.3px",
    lineHeight: 2
  },
  searchBarHeight: [50, 75],
  submitOnEnter: false
};

var SearchBar = function SearchBar(props) {
  var className = props.className,
      inputFont = props.inputFont,
      onCancelClick = props.onCancelClick,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onSubmit = props.onSubmit,
      placeholder = props.placeholder,
      searchLabel = props.searchLabel,
      searchBarHeight = props.searchBarHeight,
      showCancel = props.showCancel,
      value = props.value;
  var searchInput = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (searchInput && searchInput.current) {
      searchInput.current.focus();
    }
  }, []);
  var handleSubmit = (0, _react.useCallback)(function (evt) {
    (0, _utils.callIfFunc)(onSubmit, evt);
    evt.preventDefault();
  }, [onSubmit]);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "form",
    className: className,
    height: searchBarHeight,
    onSubmit: handleSubmit,
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, null, searchLabel || /*#__PURE__*/_react["default"].createElement(SearchIcon, {
    fill: "black",
    height: 24,
    width: 24
  })), /*#__PURE__*/_react["default"].createElement(RefInput, _extends({
    autoFocus: true,
    borderRadius: 0,
    boxShadow: 0,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    ref: searchInput,
    type: "text",
    value: value,
    width: 1
  }, inputFont)), showCancel && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    ml: 2,
    onClick: onCancelClick
  }, /*#__PURE__*/_react["default"].createElement(CancelIcon, {
    fill: "black",
    height: 16,
    width: 16
  })));
};

exports.SearchBar = SearchBar;
SearchBar.propTypes = propTypes;
SearchBar.defaultProps = defaultProps;
SearchBar.displayName = "Modules.SearchBar";
var _default = SearchBar;
exports["default"] = _default;